<template>
  <f7-page name="ozon" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Ozónové spravodajstvo</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isDataLoaded">

      <f7-block strong class="no-margin">
        <div class="text-align-center font-weight-bold text-uppercase">{{ ozonData.date_ts | moment('dddd - DD.MM.YYYY') }}</div>
        <p>Priemerná hodnota celkového atmosférického ozónu nameraného na stanici Poprad-Gánovce je:</p>
        <p class="text-align-center">
          <strong class="text-color-blue">{{ ozonData.dobson }}</strong> Dobsonových jednotiek,<br>čo je <strong class="text-color-blue">{{ komentar }}</strong>.
        </p>
        <div v-if="ozonData.comment !== null"><strong>Dodatok:</strong> <p class="no-margin-top">{{ ozonData.comment }}</p></div>
        <div v-if="ozonData.forecast !== null"><strong>Predpoveď na zajtra:</strong><p class="no-margin-top">{{ ozonData.forecast }}</p></div>
      </f7-block>
      <f7-block strong class="no-margin">

        <f7-list class="no-margin">
          <f7-list-item smart-select title="Celkový ozón v roku:" :smart-select-params="{openIn: 'popup', searchbar: false, closeOnSelect:true, popupCloseLinkText:'Zavrieť'}">
            <select v-model="selectedYear">
              <option v-for="year in yearList" :value="year">{{ year }}</option>
            </select>
          </f7-list-item>
        </f7-list>

        <template v-if="notEmptyObject(ozonHistoryData) && !isError">
          <highcharts ref="ozonHighcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>
        </template>

        <f7-list class="no-margin">
          <f7-list-item title="Odchýlka od normálu v roku:" :after="selectedYear"></f7-list-item>
        </f7-list>
        <template v-if="notEmptyObject(ozonHistoryData) && !isError">
          <highcharts ref="ozonOdchylkaHighcharts" :updateArgs="[true, true, true]" :options="chartOdchylkaOptions"></highcharts>
        </template>

      </f7-block>


    </template>
  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';

import OzonChart from './ozon-chart-options'
import OzonOdchylkaChart from './OzonOdchylka-chart-options'


Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  },
  global: {
    useUTC: true
  }
});

export default {
  components: {
    highcharts: Chart
  },
  data: function () {
    return {
      ozonData: {},
      ozonHistoryData: {},
      isError: false,
      errorMsg: null,
      isDataLoaded: false,
      isHistoryDataLoaded: false,
      isLoading: false,
      isHistoryLoading: false,
      chartOptions: OzonChart,
      chartOdchylkaOptions: OzonOdchylkaChart,
      minYear: 1994,
      maxYear: null,
      selectedYear: null,
      data_dobson: [],
      data_normal: [],
      data_odchylka: [],
      tooltipEnabled: true,


    };
  },
  watch: {

    selectedYear(v) {
      this.getHistoryData();
    },
    ozonHistoryData(v) {
      this.data_dobson = [];
      this.data_normal = [];
      this.data_odchylka = [];
      v.forEach((item) => {
        this.data_dobson.push([item.dt * 1000, item.dobson]);
        this.data_normal.push([item.dt * 1000, item.normal]);
        this.data_odchylka.push([item.dt * 1000, item.odchylka]);
      })

      let m1 = this.chartOptions.series.find(item => (item.id) === 'm1');
      m1.data = this.data_dobson;
      let m2 = this.chartOptions.series.find(item => (item.id) === 'm2');
      m2.data = this.data_normal;
      let m3 = this.chartOdchylkaOptions.series.find(item => (item.id) === 'm3');
      m3.data = this.data_odchylka;
    }

  },
  computed: {
    yearList: function() {
      let ret = [];
      for (let i = this.maxYear; i >= this.minYear; i--) {
        ret.push(i);
      }
      return ret;
    },
    komentar: function() {
      if (parseInt(this.ozonData.avg) === 0) return 'na úrovni normálu';
      else if (parseInt(this.ozonData.avg) < 0) return (0-this.ozonData.avg) + '% pod normálom';
      else return this.ozonData.avg + '% nad normálom';
    }

  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

    this.maxYear = this.$moment().format('YYYY');
    this.selectedYear = this.$moment().format('YYYY');


  },
  destroy() {

  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    updateChartData() {

      // https://codesandbox.io/s/7o37zv74rj

    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        self.$f7.dialog.preloader('Načítavam...');

        this.getData();
        this.getHistoryData();

      }
    },

    getData() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'meteo/getozoneandindexdata', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.isDataLoaded = true;
          self.ozonData = response.data.ozoneData;
          self.lastUpdated = self.$moment().unix();

        } else {
          self.$f7.dialog.alert('Nepodarilo sa načítať informácie o ozóne', 'Nastala chyba');
        }

        self.$f7.dialog.close();

        this.isLoading = false;
      }).catch((error) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },
    getHistoryData() {
      const self = this;

      self.isHistoryLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'meteo/getozonyearlydata?year='+self.selectedYear, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.isHistoryLoading = true;
          self.ozonHistoryData = response.data;
        } else {
          self.$f7.dialog.alert('Nepodarilo sa načítať informácie o ozóne', 'Nastala chyba');
        }
        this.isHistoryLoading = false;
        self.$f7.dialog.close();

      }).catch((error) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },


  }

};
</script>

